import PropTypes from "prop-types";
import ReactPortal from "../../ReactPortal/ReactPortal";
import Overlay from "../OverLay/OverLay";
import closeIcon from "../../../assets/icons/close.svg";
import classes from "./Modal.module.css";

const Modal = (props) => {
  const { header, footer, children, isOpen, onClose } = props;

  if (!isOpen) return null;

  return (
    <ReactPortal wrapperId="modal-wrapper">
      <Overlay onClick={onClose} />
      <div className={classes["modal"]}>
        <button
          className={classes["modal__close-btn"]}
          title="close"
          onClick={onClose}
        >
          <img src={closeIcon} alt="close" />
        </button>
        {header && (
          <header className={classes["modal__header"]}>
            <h2>{header}</h2>
          </header>
        )}
        <div className={classes["modal__content-wrapper"]}>{children}</div>
        {footer && (
          <footer className={classes["modal__footer"]}>{footer}</footer>
        )}
      </div>
    </ReactPortal>
  );
};
export default Modal;

Modal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  header: PropTypes.string,
  footer: PropTypes.node,
};
